define('helperUser-customStorage',['jquery', 'config'], function ($, config) {
    'use strict';

    var setCustomStorageData = function setCustomStorageData(dataContext, key, value, entityId, cbFunc) {

        if (!dataContext.previewMode) {

            var postData = {
                key: String(key),
                value: String(value),
                entityId: (entityId !== null ? entityId : undefined),
                userId: dataContext.userID
            };

            $.ajax({
                type: 'POST',
                url: config.customStorageURL + '/CreateOrUpdate',
                headers: {'Authorization-Token': dataContext.tokenID},
                data: JSON.stringify(postData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            })
                .done(function (data) {
                    if (cbFunc) cbFunc(data);
                })
                .fail(function () {
                    return false;
                });
        }

        return true;
    };


    var getCustomStorageData = function getCustomStorageData(dataContext, key, entityId, cbFunc) {

        var postData = {
            key: String(key),
            entityId: (entityId !== null ? entityId : undefined)
        };

        $.ajax({
            type: 'GET',
            url: config.customStorageURL + '/Get',
            headers: {'Authorization-Token': dataContext.tokenID},
            cache: false,
            data: postData,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        })
            .done(function (data) {
                if (cbFunc) cbFunc(data);
            })
            .fail(function () {
                return false;
            });

        return true;

    };

    var removeCustomStorageData = function removeCustomStorageData(dataContext, key, entityId, cbFunc) {

        var postData = {
            key: key,
            entityId: (entityId !== null ? entityId : undefined)
        };

        $.ajax({
            type: 'DELETE',
            url: config.customStorageURL + '/Delete',
            headers: {'Authorization-Token': dataContext.tokenID},
            cache: false,
            data: postData,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        })
            .done(function (data) {
                if (cbFunc) cbFunc(data);
            })
            .fail(function () {
                return false;
            });

        return true;

    };

    return {
        setCustomStorageData: setCustomStorageData,
        getCustomStorageData: getCustomStorageData,
        removeCustomStorageData: removeCustomStorageData
    };
});

